import React from "react";
import { useContext } from "react";
import { TemplateContext } from "../layout";
import OutsideClick from "./outsideClick";
import WarrantyPopup from "./warrantyPopup";
import CheckIcon from "/fallbacks/check.svg";
import formatCurrency from "../func/currency_formatter";
const ExtendedWarrantyCheckbox = () => {
  const [templateContext, setTemplateContext] = useContext(TemplateContext);
  const base = window.post_template;
  const showPopup = templateContext?.showPopup && templateContext?.displayPopup;
  const productPackWarrantyCheckboxTitle = templateContext?.config?.warrantyTexts?.tr_product_pack_warranty_box_title;

  const checkoutWarrantyCheckboxTitle =
    window.post_template?.checkout_v4_warranty.tr_checkout_v4_warrantyCheckboxHeading;
  const warrantyLabelRendered = productPackWarrantyCheckboxTitle
    ? productPackWarrantyCheckboxTitle
    : checkoutWarrantyCheckboxTitle;

  const formatedAmount = window.formattedString
    ? window.formattedString.replace(/(0\.00|0,00|0)/, templateContext?.config?.product?.warranty_price)
    : formatCurrency(Number(templateContext?.config?.product?.warranty_price)).toString();
  const warrantyLabel = warrantyLabelRendered.replace("###react_warrPrice###", formatedAmount);

  const toggleWarrantyCheckbox = () => {
    if (templateContext?.displayPopup && !templateContext.popupClicked) {
      setTemplateContext({
        ...templateContext,
        config: { ...templateContext.config, warrantyState: true },
        displayPopup: false,
        popupClicked: true,
        isLoading: true,
      });
    } else {
      setTemplateContext({
        ...templateContext,
        config: {
          ...templateContext.config,
          warrantyState: !templateContext.config.warrantyState,
        },
      });
    }
  };

  return (
    <>
      <section style={templateContext.displayPopup ? { zIndex: 9999 } : {}} className="warrantyContainer">
        {showPopup && (
          <OutsideClick>
            <WarrantyPopup data={base?.checkout_v4_warranty} showPopup={templateContext.showPopup} />
          </OutsideClick>
        )}
        <div className="warranty__checkbox">
          <input
            className="warranty__input"
            defaultChecked={templateContext?.config?.warrantyState}
            type="checkbox"
            id="warranty"
            onClick={() => {
              toggleWarrantyCheckbox();
            }}
          />
          <label data-cy="cc-warranty-select" className="warranty__label" htmlFor="warranty">
            {warrantyLabel ?? "Yes, I Want The Extended Protection"}
          </label>
          <label htmlFor="warranty" className="warranty__check">
            <span style={{ backgroundImage: `url(${CheckIcon})` }}></span>
          </label>
        </div>
      </section>
    </>
  );
};

export default ExtendedWarrantyCheckbox;
